export default __webpack_public_path__ + "static/media/gallery-4.50f2d7fd.jpg";